"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_spring_1 = require("react-spring");
var styled_1 = require("./styled");
var react_scrolllock_1 = tslib_1.__importDefault(require("react-scrolllock"));
var showStyle = 'translateY(0%)';
var hideStyle = 'translateY(120%)';
var Modal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, children = _a.children;
    var modalAnimStyle = react_spring_1.useSpring({
        transform: isOpen ? showStyle : hideStyle,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isOpen && react_1.default.createElement(styled_1.Overlay, { onClick: onClose }),
        react_1.default.createElement(styled_1.ModalContainer, { style: modalAnimStyle },
            children,
            react_1.default.createElement(react_scrolllock_1.default, { isActive: isOpen, accountForScrollbars: false }))));
};
exports.default = Modal;
//# sourceMappingURL=index.js.map